if (window.Groupon == null) {
  window.Groupon = {};
}

if (Groupon.Performance == null) {
  Groupon.Performance = {};
}

Groupon.Performance.pageReady = function() {
  if (typeof BOOMR.page_ready === 'function') {
    return BOOMR.page_ready();
  } else {
    return BOOMR.t_done = new Date().getTime();
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL3BlcmZvcm1hbmNlLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9wZXJmb3JtYW5jZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsSUFBMkIsc0JBQTNCO0VBQUEsTUFBTSxDQUFDLE9BQVAsR0FBaUIsR0FBakI7Ozs7RUFDQSxPQUFPLENBQUMsY0FBZTs7O0FBRXZCLE9BQU8sQ0FBQyxXQUFXLENBQUMsU0FBcEIsR0FBZ0MsU0FBQTtFQUM5QixJQUFHLE9BQU8sS0FBSyxDQUFDLFVBQWIsS0FBMkIsVUFBOUI7V0FDRSxLQUFLLENBQUMsVUFBTixDQUFBLEVBREY7R0FBQSxNQUFBO1dBR0UsS0FBSyxDQUFDLE1BQU4sR0FBbUIsSUFBQSxJQUFBLENBQUEsQ0FBTSxDQUFDLE9BQVAsQ0FBQSxFQUhyQjs7QUFEOEIifQ==
